(() => {
  let active;
  const finePointer = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const close = () => {
    if (active?.matches(':popover-open')) active.hidePopover();
    active = null;
  };
  document.addEventListener('pointerover', event => {
    const trigger = event.target.closest('[data-compact-cart] [data-cart-image-zoom]');
    if (!trigger || !finePointer() || trigger.contains(event.relatedTarget)) return;
    const preview = document.getElementById(trigger.getAttribute('popovertarget'));
    if (!preview?.showPopover) return;
    close();
    preview.showPopover();
    active = preview;
  });
  document.addEventListener('pointerout', event => {
    const trigger = event.target.closest('[data-compact-cart] [data-cart-image-zoom]');
    if (trigger && finePointer() && !trigger.contains(event.relatedTarget)) close();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-compact-cart] [data-cart-image-zoom]');
    if (!trigger || !finePointer() || event.detail === 0) return;
    const preview = document.getElementById(trigger.getAttribute('popovertarget'));
    if (!preview?.showPopover) return;
    event.preventDefault();
    if (!preview.matches(':popover-open')) preview.showPopover();
    active = preview;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') close();
  });
})();
